import React from 'react';

import Typography from '@material-ui/core/Typography';
import { makeStyles, Theme } from '@material-ui/core/styles';

import { DSTheme } from '../../../styles/themes/types';
import ThemeSwitch from './ThemeSwitch';

type PropsType = {
  onClick: () => void;
  theme: Theme;
};

const useStyles = makeStyles((theme: DSTheme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    backgroundColor: theme.palette.background.elevation1,
    width: '248px',
    height: '129px',
    borderRadius: '16px',
    boxShadow: '0px 5px 45px rgba(128, 129, 145, 0.18)',
  },
  toggleRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: '9px',
  },
  bold: {
    fontWeight: 700,
  },
}));

const WideToggle: React.FC<PropsType> = ({ onClick, theme }) => {
  const classes = useStyles();
  const isDarkTheme = theme.palette.type === 'dark';
  const textColour = isDarkTheme ? 'textPrimary' : 'textSecondary';

  return (
    <div className={classes.container}>
      <Typography color={textColour}>Try our Experimental feature</Typography>

      <div className={classes.toggleRow}>
        <Typography color={textColour} className={isDarkTheme ? classes.bold : ''}>
          Dark
        </Typography>
        <ThemeSwitch aria-label="ThemeToggle" onClick={onClick} checked={!isDarkTheme} />
        <Typography color={textColour} className={isDarkTheme ? '' : classes.bold}>
          Light
        </Typography>
      </div>
    </div>
  );
};

export default WideToggle;
